import { useState } from 'react'
import api from '../../utils/api'
import useToastContext from '../useToastContext'
import { notificationTypes } from '../../contexts/toastContext'

const useEventsApi = () => {
  const addToast = useToastContext()

  const [eventsState, setEventsState] = useState({
    events: [],
    count: 0,
    isLoading: false,
    error: null,
  })

  async function getEvents(params) {
    try {
      setEventsState((currentEventsState) => ({
        ...currentEventsState,
        isLoading: true,
        error: null,
      }))
      let url = '/events'
      const response = await api.get(url, { params, includeToken: true })
      setEventsState({
        events: response.data.data,
        count: response.data.count,
        isLoading: false,
        error: null,
      })
    } catch (error) {
      setEventsState({ events: [], isLoading: false, error })
    }
  }

  async function addEvent(event) {
    try {
      // const events = currentEventsState.events.slice()
      setEventsState((currentEventsState) => ({
        ...currentEventsState,
        events: [event],
        count: currentEventsState.count + 1,
        isLoading: false,
        error: null,
      }))
    } catch (error) {
      setEventsState({ events: [], isLoading: false, error })
    }
  }

  async function createManualEvent(data, params) {
    try {
      setEventsState((currentCreateDoorbellState) => ({
        ...currentCreateDoorbellState,
        isLoading: true,
        error: null,
      }))
      const created = await api.post('/events/manual', data)
      setEventsState({
        isLoading: false,
        error: null,
      })
      addToast(notificationTypes.success, 'Evento creado con exito!')
    } catch (error) {
      addToast(notificationTypes.error, `${error?.response?.data?.message}`)
      setEventsState({ isLoading: false, error })
    }
  }

  const state = {
    eventsState,
  }

  const methods = {
    getEvents,
    addEvent,
    createManualEvent,
  }

  return [state, methods]
}

export default useEventsApi
